import templateUrl from 'emun.salesrep/credithold-orders.htm'
import AutoQuery from 'servicestack/auto-query/auto-query'
import basicController from 'servicestack/basic.controller.properties'
import resolve from 'ioc/resolve'

class CreditHoldCorporateOrdersController {
  constructor($rootScope) {
    const $ctrl = this;
    basicController($ctrl);


    var context = $ctrl.context || 'rep';
    var repFilter = "";
    if (context != 'executive') {
      var filterType = "SalesRepID";
      if (context == 'manager') {
        filterType = 'ManagerId';
      }
      repFilter = "&" + filterType + "=" + $ctrl.rep.id;
    }


    //var filter = "SalesRepID";
    //if (context == 'manager') { filter = "ManagerId";}

    $ctrl.creditholdOrders = new AutoQuery({
      url: 'QueryCartsJoin.json?ReviewReason=Credit Hold' + repFilter,
      orderBy: '-OrderedOn',
      autoLoad: true,
      pageSize: 10,
      scrollTop: false
    })
  }
}

let CreditHoldCorporateOrders = {
  bindings: {
    repId: '@',
    context: '@',
    rep: '<'
  },
  controller: CreditHoldCorporateOrdersController,
  templateUrl($element, $attrs) {
    return $attrs.templateUrl || templateUrl
  }
}

export default CreditHoldCorporateOrders